import { useDispatch, useSelector } from 'react-redux';
import { useCssHandles } from '../../utils/functions';
import { selectFirstLevel, setSelectedFirstLevel } from '../../redux/megaMenuSlice';

const CSS_HANDLES = [
	'menuItemVertical',
	'styledLinkContainer',
	'styledLink',
	'styledLinkContent',
	'styledLinkText',
	'styledLinkIcon',
	'accordionIconContainer',
	'caretIcon',
];
const FirstLevel = ({ name, blockClass, isSelected, index }) => {
	const dispatch = useDispatch();
	const { handles } = useCssHandles('vtex-mega-menu-2-x', CSS_HANDLES, blockClass);
	const { handles: handles2 } = useCssHandles(
		'vtex-mega-menu-2-x',
		CSS_HANDLES,
		blockClass,
		isSelected ? 'isOpen' : 'isClosed',
	);

	return (
		<li
			className={`${handles.menuItemVertical} bb b--light-gray bt ${isSelected ? 'bg-black-05' : ''}`}
			onClick={() => dispatch(setSelectedFirstLevel(index))}
		>
			<div className={`${handles.styledLinkContainer} pv5 mh5`}>
				<button className={`${handles.styledLink} no-underline c-on-base w-100 pa0 t-body pointer`}>
					<div className={`${handles.styledLinkContent} flex justify-between`}>
						<div className={`${handles.styledLinkText} flex justify-between items-center nowrap`}>{name}</div>

						<div className={`${handles2.accordionIconContainer} ml1 c-muted-3`}>
							<svg
								fill="none"
								width="16"
								height="16"
								viewBox="0 0 16 16"
								className={`${handles.caretIcon}`}
								xmlns="http://www.w3.org/2000/svg"
							>
								<use href="#nav-caret--right"></use>
							</svg>
						</div>
					</div>
				</button>
			</div>
		</li>
	);
};

export default FirstLevel;
